module.exports = __webpack_public_path__ + "img/drh5_icon_fb.3a0c3154.png";